/* eslint-disable @typescript-eslint/no-explicit-any*/
import { BANK_LIST, BANK_DETAILS } from '~/actions/actionTypes';

const initialState: reducers.BankReducer = {
  list: [],
  detail: null,
};

const bankReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case BANK_LIST:
      state = {
        ...state,
        list: action.payload.rows,
      };
      break;

    case BANK_DETAILS:
      state = {
        ...state,
        detail: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default bankReducer;
